<template>
  <div class="form-element -password" :class="{ '-login': isLoginPage }">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <input
      class="form-element__input"
      :class="classObj"
      :type="inputType"
      name="password"
      :placeholder="placeholder"
      autocomplete="false"
    
      @keyup="changed"
      @focus="makeWriteable"
      @blur="makeReadable"
      v-model.trim="val"
     
    />
    <span class="form-element__eye" @click="changeType()" v-if="isEyeVisible"
      ><icon-eye :isOpen="isOpen"
    /></span>
    <div class="form-element__message" v-if="message && !forceRule">
      {{ message }}
    </div>
    <div class="form-element__message" v-if="forceRule">
      Şifreniz 6 karekterden oluşmalı ve sadece rakam içermelidir. <br>
      Belirleyeceğiniz şifre "Tek Şifre" politikası ile Katılım Cep uygulamasında da geçerli olacaktır. 
    </div>
  </div>
</template>

<script>
import { letter, numeric } from '@/directives/'
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    extraClass: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "Şifre",
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    isEyeVisible: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    forceRule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      val: this.value,
      read: true,
      isLoginPage: this.$route.meta.layout == "login",
      inputType: "password",
    };
  },
  directives: { letter, numeric },
  computed: {
    isOpen: function () {
      return this.inputType == "password";
    },
    classObj: function () {
      let style = [this.isError ? `-error` : "", `${this.extraClass}`];

      return style;
    },
  },
  methods: {
    changed: function (e) {
      let status = this.checkPAssworRule(e.target.value);

      if (!status) return this.$emit("input", null);

      this.$emit("input", e.target.value);

      return e.target.value;
    },
    checkPAssworRule: function (pass) {
      if (!this.forceRule) return true;
    
        if(pass.length < 6 || pass.length >6)
        {
        return false;
        }
      // let lowerLetterCheck = pass.match(/[a-z]+/);

      // let upperLetterCheck = pass.match(/[A-Z]+/);

      let numericCheck = pass.match(/[0-9]+/);

      // let symbolCheck = pass.match(/[$@#&!--*]+/);

      // let status =
      //   lowerLetterCheck && upperLetterCheck && numericCheck && symbolCheck;
      let status = numericCheck
      return status;
    },
    makeWriteable: function () {
      this.read = false;
    },
    makeReadable: function () {
      this.read = true;
    },
    changeType: function () {
      let vm = this;

      if (vm.inputType == "text") return (vm.inputType = "password");

      return (vm.inputType = "text");
    },
  },
};
</script>